import React from 'react'
import ReactDOM from 'react-dom'
import _ from 'lodash'

export default class QmlComponent extends React.Component {
    static cardName = `REG/SubTaskProgress.qml`;
    
    constructor() {
        super()
        this._ismounted = false
        this.state = {
            qml : null
        }
    }

    componentDidMount() {
        this._ismounted = true
        //console.log("!!!<<<<<<CDM>>>>>>>!!! ", this.cardName)
        

        //console.log('about to this.loadQML')
// Soure code from QML file starts here 
setTimeout( () => { 
this.loadQML(String.raw`
import Semantic.Html 1.0
import QmlWeb 1.0
import '../Common' as Common
import '../Common/Util.js' as Util

Segment {
    id: segProgress
    displayNone: true
    property var progressMapper: {}
    property var interval: null
    RestModel {
        id: rmdProgress
        url: '/apis/core/task/'
        property var running_tasks: []
        property var failed_tasks: []
        property var succeeded_tasks: []
        onFetched: {
            running_tasks.forEach(function(item) {
                segProgress.updateProgressElement(item)
            })
            failed_tasks.forEach(function(item) {
                segProgress.updateProgressElement(item)
            })
            succeeded_tasks.forEach(function(item) {
                segProgress.updateProgressElement(item)
            })
        }
    }
    RestModel {
        id: rmdTaskDetail
        property string task_id
        onSaved: {
            segProgress.progressMapper[task_id].$container.remove()
            segProgress.progressMapper[task_id] = null
            delete segProgress.progressMapper[task_id];
            console.log(Object.keys(segProgress.progressMapper))
            if (Object.keys(segProgress.progressMapper).length === 0) {
                segProgress.displayNone = true
            }
        }
        onFailed: {
            Util.danger(_('เกิดข้อผิดพลาด'))
        }
    }
    Component.onCompleted: {
        rmdProgress.fetch()
        if (segProgress.interval) {
            clearInterval(segProgress.interval)
        }
        segProgress.interval = setInterval(function() {
            rmdProgress.fetch()
        }, 3 * 1000)
    }
    function updateProgressElement(item) {
        var taskId = item.task_id, 
            taskName = item.task_name, 
            state = item.state, 
            current = item.current, 
            total = item.total, 
            error = item.error;

        var progressSettings = {
            total: total,
            value: current,
            text: {
                active: taskName + _(' ดำเนินการ {value} จาก {total}'),
                success: taskName + _(' {total} รายการสำเร็จ'),
                error: taskName + _(' เกิดข้อผิดพลาด {error}').format({error: error}),
            }
        }

        if (! progressMapper[taskId]) {
            var $progress = $(
                '<div class="ui indicating brown inverted progress" style="flex-basis: 95%">' +
                    '<div class="bar">' +
                        '<div class="progress"></div>' +
                    '</div>' +
                    '<div class="label">กำลังดำเนินการ</div>' +
                '</div>'
            )
            var $button = $(
                '<button class="ui icon compact button" style="flex-basis: 4%; margin: 0em 0em 2.5em;">' +
                    '<i class="checkmark icon"></i>' +
                '</button>'
            )
            var $container = $(
                '<div style="display: flex; justify-content: space-between;"></div>'
            )

            progressMapper[taskId] = {
                $progress: $progress,
                $button: $button,
                $container: $container,
            }
            segProgress.displayNone = false
            $container.append($progress)
            $container.append($button)
            $container.appendTo($(segProgress.dom))
            $progress.progress(progressSettings)
            $button.on('click', function() {
                rmdTaskDetail.url = '/apis/core/task/{taskId}/acknowledge/'.format({taskId: taskId})
                rmdTaskDetail.save()
            })
        } else {
            var $progress = progressMapper[taskId].$progress
            var $button = progressMapper[taskId].$button
        }

        switch(state) {
            case 'PENDING': {
                $button.hide()
                break
            }
            case 'PROGRESS': {
                $button.hide()
                $progress.progress('set progress', current)
                break
            }
            case 'FAILURE': {
                $button.show(300)
                $progress.progress('set error')
                $progress.progress('set label', progressSettings.text.error)
                break
            }
            case 'SUCCESS': {
                $button.show(300)
                $progress.progress('set progress', current)
                $progress.progress('set success')
            }
        }
    }
}
        `)
}, 0)

    }

    componentWillUnmount() {
        this._ismounted = false
        //console.log(" ***** componentWillUnmount ", this.cardName)
        document.onkeypress = null;
        document.onkeyup = null;

        // this.engine.stop()
        if(this.qml){
            this.qml.destroy()
            this.removeChildProperties(this.qml)
        }
        
        // this.qml = null
        // this.engine = null
        if(this.props.onUnmount){
            this.props.onUnmount()
         }
        // window.QmlWeb.engine.dom = null
        // window.QmlWeb.engine.domTarget = null
        // window.QmlWeb.engine.rootObject = null
        // window.QmlWeb.engine.completedSignals = []
        // window.QmlWeb.engine = {}
        //console.log(" ***** componentWillUnmount Finish ", this.cardName)
    }

    loadQML = (src, parentComponent = null, file = undefined) => {
        this.loadQMLTree(window.QmlWeb.parseQML(src, file), parentComponent, file);
        
        // let component = this.loadQMLTree(window.QmlWeb.parseQML(src, file), parentComponent, file);
        // this.qml = this.engine.rootObject
        // return component
    }

    loadQMLTree = (tree, parentComponent = null, file = undefined) => {

        // Part 1
        let QMLComponent; 
        let component;

        setTimeout( () => { 

            if (!this._ismounted){
                //console.log(" Shutdown Part 1", this.cardName)
                return;
            }
            this.engine = window.QmlWeb.engine;
        
            if (!this.engine) {
                this.engine = new window.QmlWeb.QMLEngine(ReactDOM.findDOMNode(this));
                // window.addEventListener("resize", () => this.engine.updateGeometry());
            } else {
                this.engine.cleanEngine(ReactDOM.findDOMNode(this))
            }

            this.engine.$basePathA = document.createElement('a')
            this.engine.$basePathA.href = this.extractBasePath(`/static/qml/REG/SubTaskProgress.qml`)
            this.engine.$basePath = this.engine.$basePathA.href
            //console.log(" CDM this.engine.$basePathA.href: ", this.engine.$basePathA.href)

            window.QmlWeb.engine = this.engine;

            // Create and initialize objects
            QMLComponent = window.QmlWeb.getConstructor("QtQml", "2.0", "Component");
            component = new QMLComponent({
                object: tree,
                parent: parentComponent
            });
            //console.log("Part 1", this.cardName)
        },0)

        setTimeout(() => {
            if (!this._ismounted){
                //console.log(" Shutdown Part 2", this.cardName)
                return;
            }
            
            this.engine.loadImports(tree.$imports, undefined, component.importContextId);
            component.$basePath = this.engine.$basePath;
            component.$imports = tree.$imports; // for later use
            component.$file = file; // just for debugging
            //console.log("Part 2", this.cardName)
        }, 0);
    

        // Part 3,4,5
        setTimeout(() => {
            if (!this._ismounted){
                //console.log(" Shutdown Part 3", this.cardName)
                return;
            }
            this.engine.rootObject = component.$createObject(parentComponent);
            
            if (this.engine.rootObject.dom) {
                this.engine.domTarget.appendChild(this.engine.rootObject.dom);
            }
     
            this.qml = this.engine.rootObject
            this.setUpSignals()
            this.setUpProperties()
            //console.log("3. setUpSignals(), setUpProperties() Done", this.cardName)
 
            this.engine.$initializePropertyBindings();
            this.engine.start();

            this.engine.updateGeometry();
            this.qml = this.engine.rootObject

            this.setState({qml: this.qml})
            //console.log("4. finish loadQMLTree", this.cardName)

            
            this.engine.firstCallCompleted = false;
            this.engine.callCompletedSignals();
            this.engine.firstCallCompleted = true;
            //console.log("5. CallCompletedSignal", this.cardName)

            if (this.props.completedQMLLoad) {
                //console.log("Callback completedQMLLoad !!")
                setTimeout( () => {
                    this.props.completedQMLLoad()
                })
            }
        }, 0);
    }
    
    deCapitalizeFirstLetter(string) {
        return string.charAt(0).toLowerCase() + string.slice(1);
    }

    hasSignalName(signalName) {
        return (
            typeof this.qml[signalName] === 'function' 
            && typeof this.qml[signalName].connect === 'function'
        )
    }

    setUpSignals() {
        _.forOwn(this.props, (value, key) => {
            let signalName = this.deCapitalizeFirstLetter(key.replace('on', ''))
            let startsWithOn = key.startsWith('on')
            let typeFunction = typeof value === 'function'
            if (!startsWithOn || !typeFunction) {
                return
            }
            if (!this.hasSignalName(signalName)) {
                console.warn('Cannot find a signal name: ' + signalName)
                return
            }
            this.qml[signalName].disconnect()
            this.qml[signalName].connect(this.qml, value)
        })
    }

    setUpProperties() {
        _.forOwn(this.props, (value, key) => {
            let signalName = this.deCapitalizeFirstLetter(key.replace('on', ''))
            let propertyExists = typeof this.qml.$properties[key] !== 'undefined'
            if (this.hasSignalName(signalName)) {
                return
            }
            if (!propertyExists) {
                const createProperty = window.QmlWeb.createProperty;
                createProperty("variant", this.qml, key, value);
                //console.warn('Cannot find a property name: ' + key)
                // return
            }
            this.qml[key] = value
        })
    }

    extractBasePath(file) {
        const basePath = file.split(/[/\\\\]/)
        basePath[basePath.length - 1] = ''
        return basePath.join('/')
    }

    extractFileName(file) {
        return file.split(/[/\\\\]/).pop()
    }

    removeChildProperties(child) {
        const signals = this.engine.completedSignals
        if (signals) {
            signals.splice(signals.indexOf(child.Component.completed), 1)
        }
        if(child.children) {
            for (let i = 0; i < child.children.length; i++) {
                this.removeChildProperties(child.children[i])
            }
        }
        child.$signals = null
    }

    render() {
        if (this.state.qml) {
            this.setUpSignals()
            this.setUpProperties()
        }
        return React.createElement('div')
    }
}